var exports = {
  "ZA": "x936d19a0--753b8a--suggest",
  "rg": "x936d19a0--753b8a--suggest-item",
  "e5": "x936d19a0--753b8a--suggest-error",
};

module.exports = exports;
